import { LayoutFrame } from './Layout';

/** Marketing shares the system frame with only its own navigation entries. */
export default function LayoutMarketing() {
  return <LayoutFrame accountOnly />;
}
